module.exports = __webpack_public_path__ + "img/lake-cabin-12.20e1cc59.jpg";